// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1LqMr","title":"Images90_title__2hBdX","images":"Images90_images__QKg73"};